/**
 * Универсальная утилита для проверки дубликатов имен документов
 * Следует принципам DRY - переиспользуемая логика
 * @param {string} fileName - Имя файла для проверки
 * @param {Array<{name: string}>} existingDocuments - Массив существующих документов
 * @returns {boolean} - true, если имя уже существует
 */
const checkDocumentNameDuplicate = (fileName, existingDocuments) => {
  if (!fileName || !existingDocuments || !Array.isArray(existingDocuments)) {
    return false;
  }
  
  return existingDocuments.some(document => 
    document.name && document.name.toLowerCase() === fileName.toLowerCase()
  );
};

/**
 * Проверяет наличие дубликатов среди загружаемых документов
 * @param {Array<{name: string}>} documentsToCheck - Массив документов для проверки
 * @returns {boolean} - true, если есть дубликаты
 */
export const hasDuplicateNames = (documentsToCheck) => {
  if (!documentsToCheck || documentsToCheck.length === 0) {
    return false;
  }
  
  const names = documentsToCheck.map(doc => doc.name?.toLowerCase()).filter(Boolean);
  const uniqueNames = new Set(names);
  return names.length !== uniqueNames.size;
};

/**
 * Проверяет наличие дубликатов с существующими документами
 * @param {Array<{name: string}>} documentsToCheck - Массив документов для проверки
 * @param {Array<{name: string}>} existingDocuments - Массив существующих документов
 * @returns {boolean} - true, если есть дубликаты
 */
export const hasDuplicatesWithExisting = (documentsToCheck, existingDocuments) => {
  if (!documentsToCheck || documentsToCheck.length === 0) {
    return false;
  }
  
  for (let i = 0; i < documentsToCheck.length; i++) {
    const document = documentsToCheck[i];
    if (checkDocumentNameDuplicate(document.name, existingDocuments)) {
      return true;
    }
  }
  
  return false;
};

/**
 * Проверяет наличие любых дубликатов (среди загружаемых и с существующими)
 * @param {Array<{name: string}>} documentsToCheck - Массив документов для проверки
 * @param {Array<{name: string}>} existingDocuments - Массив существующих документов
 * @returns {boolean} - true, если есть дубликаты
 */
export const hasAnyDuplicates = (documentsToCheck, existingDocuments = []) => {
  return hasDuplicateNames(documentsToCheck) || 
         hasDuplicatesWithExisting(documentsToCheck, existingDocuments);
};

export default checkDocumentNameDuplicate;

